import React from 'react'
import { useDispatch } from 'react-redux'
import { fetchSelectedOdds, selectOdd } from '../LiveSlice'
import { LiveOdds } from '../types'
import styles from './Odd.module.css'

interface Props extends LiveOdds {
  isActive: Boolean
  gameId: number
  championshipId: number
}

const Odd = ({ Id, type, active, paused, snatch, title, isActive, gameId, championshipId }: Props) => {
  const dispatch = useDispatch()
  const oddClick = (e: React.MouseEvent<HTMLDivElement>): void => {
    e.stopPropagation()
    if (type !== 'locked') dispatch(selectOdd({ Id: Number(Id), gameId, championshipId }))
    // setTimeout(() => {
    //   dispatch(fetchSelectedOdds())
    // }, 0);
  }
  return (
    <div
      onClick={oddClick}
      className={`${styles.odd} 
                  ${isActive && type !== 'locked' ? styles.active : ''} 
                  ${type ?? styles[type]}`}
    >
      {title}
      {type === 'locked' ? (
        <span className={styles.locked}></span>
      ) : (
        <span className={styles.snatch}>{snatch}</span>
      )}
    </div>
  )
}

export default React.memo(Odd)